export default {
  ["connecting"](state, connecting) {
    state.connecting = connecting;
  },
  ["reconnecting"](state, reconnecting) {
    state.reconnecting = reconnecting;
  },
  ["connected"](state, connected) {
    state.connected = connected;
  },
  ["denied"](state, denied) {
    if (!state.reconnecting) {
      state.denied = denied;
    }
  },
  ["connectionWatch"](state, watch) {
    state.connectionWatch = watch;
  },
  ["user"](state, user) {
    state.user = user;
    localStorage.setItem("user", JSON.stringify(user));
  }
};
